<div class="col-sm-12">
    <h3>Atualizar convênio</h3>
    <hr>

    <div class="col-sm-12">
        <ul class="timeline">
            <li class="time-label">
                <span class="bg-red">Etapa 1</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">
                    <h3 class="timeline-header">
                        <a (click)="openEtapa1()" style="cursor: pointer;">1 - CONCEDENTE, TÍTULO, TIPO E DESCRIÇÃO</a>
                    </h3>
                    <div class="timeline-body" *ngIf="etapa1">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <div class="ui-g-6 ui-fluid" style="padding: 0;"
                                    *ngIf="isAdmin">
                                    <label>Entidade Concedente:</label>
                                    <p-select name="entidadeConcedente" [options]="entidadesConcedente"
                                        placeholder="Selecione" [filter]="true"
                                        [(ngModel)]="dispensaInexigibilidade.entidadeConcedente.id"
                                        (onChange)="buscarConcedente($event.value)" required></p-select>
                                </div>
                            </div>

                            <div class="form-group col-sm-6">
                                <label>Defina o tipo de processo:</label>
                                <div class="form-group">
                                    <div class="radio">
                                        <label>
                                            <input type="radio" name="optionsRadios" id="optionsRadios2"
                                                [checked]="true"> Processo por parceria
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <hr>
                            </div>
                            <div class="form-group col-sm-12">
                                <label>Título:</label>
                                <input type="text" name="titulo" [(ngModel)]="dispensaInexigibilidade.titulo"
                                    class="form-control">
                            </div>
                            <div class="col-sm-12">
                                <p-editor placeholder="Descrição"
                                    [(ngModel)]="dispensaInexigibilidade.descricao">
                                </p-editor>
                            </div>
                        </div>
                    </div>

                    <div class="timeline-footer" *ngIf="etapa1">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 2</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa2()" style="cursor: pointer;">2 – ANEXOS DA PROPOSTA</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa2">

                        <div class="col-sm-12">

                            <label>Anexar arquivo: </label>
                            <a class="btn btn-primary btn-sm" (click)="openModalUpload('convenios')">
                                <i class="fa fa-paperclip"></i>
                            </a>

                            <table class="table" *ngIf="anexosSalvos.length != 0">

                                <thead>
                                    <tr>
                                        <th width="50%">Nome arquivo Existentes</th>

                                        <th class="text-center">Remover/excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of anexosSalvos">
                                        <td><strong>{{item.proposta }}</strong></td>
                                        <td class="text-center">
                                            <span>
                                                <i class="glyphicon glyphicon-remove cursor"
                                                    (click)="confimarExclusao(item, 'existente')">
                                                </i>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table" *ngIf="dataUploadArray.length != 0">

                                <thead>
                                    <tr>
                                        <th width="50%">Nome arquivo Novos</th>

                                        <th class="text-center">Remover/excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataUploadArray">
                                        <td><strong>{{item.originalname}}</strong></td>
                                        <td class="text-center">
                                            <span>
                                                <i class="glyphicon glyphicon-remove cursor"
                                                    (click)="confimarExclusao(item, 'novo')">
                                                </i>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>





                        </div>


                    </div>

                    <div class="timeline-footer" *ngIf="etapa2">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa1()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 3</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa3()" style="cursor: pointer;">3 – ESCOLHA DA ENTIDADE</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa3">

                        <div class="ui-g-12 ui-fluid">
                            <label>OSCs:</label>
                            <p-select name="Oscs" [options]="listaOscs" placeholder="Selecione"
                                [filter]="true" [(ngModel)]="planoTrabalho.entidadeProponente.id"
                                (onChange)="buscarProponente($event.value)"></p-select>
                        </div>
                        <div class="ui-g-12 ui-fluid">
                            <p-editor placeholder="Justificativa" [(ngModel)]="planoTrabalho.justificativa">
                            </p-editor>
                        </div>

                        <hr>






                    </div>
                    <div class="timeline-footer" *ngIf="etapa3">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 4</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa4()" style="cursor: pointer;">4 – ORÇAMENTO PROJETO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa4">

                        <div class="form-group col-sm-6">
                            <label>Unidade Orçamentária:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2UnidadeOrcamentaria"
                                class="form-control">
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Fonte:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2Fonte" class="form-control">
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Dotação Orçamentária:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2DotacaoOrcamentaria"
                                class="form-control">
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Elemento Despesa:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2ElementoDespesa"
                                class="form-control">
                        </div>
                        <div class="form-group col-sm-3">
                            <label>Valor:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2Valor" class="form-control"
                                placeholder="R$ 0.000,00" currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }">
                        </div>
                        <div class="form-group col-sm-9">
                            <label>Valor por extenso:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2ValorExtenso"
                                class="form-control">
                        </div>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa4">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa5()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 5</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa5()" style="cursor: pointer;">5 – CONFIRMAR CADASTRO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa5">

                        <p>Tipo de processo:</p>
                        <h4 class="text-light-blue"><b>{{ retornaTipoProposta() }}</b></h4>
                        <hr>
                        <p>Título e descrição:</p>
                        <div style="border: 1px solid #eee; margin-left: 12px; padding: 10px;">
                            <h4 class="text-light-blue"><b>{{ dispensaInexigibilidade.titulo }}</b></h4>
                            <hr>
                            <div [innerHtml]="dispensaInexigibilidade.descricao"></div>
                        </div>
                        <hr>
                        <p>Link dos Anexos</p>
                        <div *ngFor="let anexo of anexosSalvos">
                            <a style="cursor: pointer;" (click)="openModalAnexo(anexo)"> Anexo:
                                {{anexo.proposta}}</a>
                        </div>
                        <!--  <div *ngFor="let anexo of dataUploadArray">
                            <a style="cursor: pointer;" (click)="openModalAnexo(anexo, 'novo')"> Anexo:
                                {{anexo.originalname}}</a>
                        </div> -->
                        <hr>
                        <p>Justificativa / Orçamento / Entidade(s):</p>
                        <div style="border: 1px solid #eee; margin-left: 12px; padding: 10px;">
                            <div *ngIf="!dispensaCredenciamento">
                                <h4 class="text-light-blue"><b>{{ retornaNomeEntidade() }}</b></h4>
                                <hr>
                                <p><b>Justificativa:</b></p>
                                <div [innerHtml]="planoTrabalho.justificativa"></div>
                                <hr>

                                <p><b>Orçamento projeto:</b></p>
                                <dl class="dl-horizontal">
                                    <dt>Unidade orçamentária: </dt>
                                    <dd>{{ planoTrabalho.et2UnidadeOrcamentaria }}</dd>
                                    <dt>Fonte: </dt>
                                    <dd>{{ planoTrabalho.et2Fonte }}</dd>
                                    <dt>Dotação orçamentária: </dt>
                                    <dd>{{ planoTrabalho.et2DotacaoOrcamentaria }}</dd>
                                    <dt>Elemento despesa: </dt>
                                    <dd>{{ planoTrabalho.et2ElementoDespesa }}</dd>
                                    <dt>Valor: </dt>
                                    <dd>{{ planoTrabalho.et2Valor }}</dd>
                                    <dt>Valor por extenso: </dt>
                                    <dd>{{ planoTrabalho.et2ValorExtenso }}</dd>
                                </dl>
                            </div>
                        </div>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa5">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Voltar</a>
                        <a class="btn btn-success btn-sm" (click)="salvar()">SALVAR ATUALIZAÇÕES</a>
                    </div>
                </div>
            </li>
        </ul>
    </div>

</div>


<p-dialog [(visible)]="openModalViewUpload" width="700" showEffect="fade" [modal]="true">
    <div class="col-sm-12">
        <h3>Upload de arquivos.</h3>
        <button type="button" class="btn btn-success  btn-sm" (click)="adicionarArquivo()">
            <i class="fa fa-fw fa-save"></i> Salvar
        </button>
        <hr>
    </div>
    <div class="col-sm-12">
        <app-upload-service></app-upload-service>
        <hr>
    </div>
</p-dialog>

<p-dialog [style]="{width: '800px'}" header="{{nomeAnexo}}" [(visible)]="displayAnexo" showEffect="fade" [modal]="true">
    <div class="col-sm-12">
        <h3>Anexo</h3>
        <hr>
    </div>
    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>
    </div>
</p-dialog>